import { render } from "./MessageNotification.vue?vue&type=template&id=3cf0e708&scoped=true"
import script from "./MessageNotification.vue?vue&type=script&lang=js"
export * from "./MessageNotification.vue?vue&type=script&lang=js"

import "./MessageNotification.vue?vue&type=style&index=0&id=3cf0e708&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf0e708"]])

export default __exports__